var _path, _path2, _path3, _path4, _path5, _path6, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallengesub3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 85,
    viewBox: "0 0 83 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.954 15H9.78474C7.40567 15 5.47705 16.9286 5.47705 19.3077V66.6923C5.47705 69.0714 7.40567 71 9.78474 71H70.954C73.333 71 75.2617 69.0714 75.2617 66.6923V19.3077C75.2617 16.9286 73.333 15 70.954 15Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47705 28.7847H75.2617",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2309 23.6153C14.1825 23.6153 14.954 22.8439 14.954 21.8923C14.954 20.9406 14.1825 20.1692 13.2309 20.1692C12.2793 20.1692 11.5078 20.9406 11.5078 21.8923C11.5078 22.8439 12.2793 23.6153 13.2309 23.6153Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.831 23.6153C19.7826 23.6153 20.5541 22.8439 20.5541 21.8923C20.5541 20.9406 19.7826 20.1692 18.831 20.1692C17.8794 20.1692 17.1079 20.9406 17.1079 21.8923C17.1079 22.8439 17.8794 23.6153 18.831 23.6153Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4313 23.6153C25.383 23.6153 26.1544 22.8439 26.1544 21.8923C26.1544 20.9406 25.383 20.1692 24.4313 20.1692C23.4797 20.1692 22.7083 20.9406 22.7083 21.8923C22.7083 22.8439 23.4797 23.6153 24.4313 23.6153Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8771 41.277L18.4001 50.3231L27.8771 59.3693M52.8617 41.277L62.3386 50.3231L52.8617 59.3693M45.5386 36.9693L35.2001 63.677",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.82843,
    y1: 2,
    x2: 81,
    y2: 80.1716,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 112.551,
    y2: -2,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0 83)",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesub3);
export default __webpack_public_path__ + "static/media/challengesub3.7e0cf21b96b654af920769c6f7a4543c.svg";
export { ForwardRef as ReactComponent };